// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"G5-z"};